import { useState } from "react";
import { useSnackbar as useLameSnackbar } from "notistack";
import { useSelector } from "react-redux";
import { useHistory, useParams } from "react-router";
import { RootState } from "../../state/configureStore";
import LoadingButton from "../Loading/LoadingButton";

export const useSnackbar = () => {
  const { enqueueSnackbar } = useLameSnackbar();
  return (message: string, variant: "success" | "error", autoHideDuration: number = 3000) =>
    enqueueSnackbar(message, { autoHideDuration, variant });
};

export const useAssignmentModalState = () => {
  const [loadingButtonState, changeLoadingButtonState] = useState(LoadingButton.BeforeLoading);
  const loadingProps = { loadingButtonState, changeLoadingButtonState };
  const enqueueSnackbar = useSnackbar();
  const { assignmentId } = useParams<{ assignmentId: string }>();
  const assignment = useSelector((state: RootState) => state.teacherState.assignments[assignmentId]);
  const title = assignment?.assignmentDetails.title || "";
  const history = useHistory();

  return { loadingProps, enqueueSnackbar, assignmentId, assignment, title, history };
};
